import axios from 'axios';

export const doctorReviewRequest = async ({ id, status, comment }) => {
  const body = {
    status: status,
    dr_comments: comment
  };
  if ((!comment || comment == '') && status == 'APPROVED') {
    body.dr_comments = 'Approved by Doctor!';
  }

  return await axios.patch(`/doctor/review-request/${id}`, body);
};

export const getHistory = async (id) => {
  return await axios.get(`/doctor/history/${id}`);
};

export const editHistory = async (id, history) => {
  return await axios.patch(`/doctor/history/${id}`, { history: history });
};
